<template>
   <div class="tabulation">
      <el-card class="chart-card">
         <div style="margin-top: 20px;">
            <el-form ref="ruleFormRef" :model="form" :rules="rules" class="demo-ruleForm" :size="formSize" status-icon>
               <el-form-item label="所属工会" prop="unionName">
                  <div class="aaaa">
                     <el-select v-model="form.unionName" placeholder="请选择工会" size="large" @click="openUnionDialog" @focus="closeUnionSelect" ref="unionSelectRef" clearable @clear="clearUnion" />
                  </div>
               </el-form-item>
               
               <el-form-item label="统计方式" prop="standardType">
                  <div class="aaaa">
                     <el-select v-model="form.standardType" placeholder="请选择统计方式" clearable>
                        <el-option label="每日步数达标天数" :value="1" style="width:100%; text-align-last: center;" />
                        <el-option label="月总步数" :value="2" style="width:100%; text-align-last: center;" />
                        <el-option label="排行榜" :value="3" style="width:100%; text-align-last: center;" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item v-show="form.standardType === 1" prop="standardSteps">
                  <template #label><span class="required-mark">*</span>每天达标步数</template>
                  <div class="aaaa">
                     <el-input v-model.number="form.standardSteps" type="text" placeholder="请填写每天达标步数" />
                  </div>
               </el-form-item>

               <el-form-item v-show="form.standardType === 1" prop="standardDays">
                  <template #label><span class="required-mark">*</span>达标天数</template>
                  <div class="aaaa">
                     <el-input v-model.number="form.standardDays" type="text" placeholder="请填写达标天数" />
                  </div>
               </el-form-item>

               <el-form-item v-show="form.standardType === 2" prop="totalStandardSteps">
                  <template #label><span class="required-mark">*</span>达标总步数</template>
                  <div class="aaaa">
                     <el-input v-model.number="form.totalStandardSteps" type="text" placeholder="请填写达标总步数" />
                  </div>
               </el-form-item>

               <el-form-item label="是否展示排行榜" prop="isShowRanking">
                  <div class="aaaa">
                     <el-select v-model="form.isShowRanking" placeholder="请选择是否展示排行榜" clearable>
                        <el-option label="展示" :value="1" style="width:100%; text-align-last: center;" />
                        <el-option label="不展示" :value="2" style="width:100%; text-align-last: center;" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item label="是否定时发送短信" prop="isTimingSendSms">
                  <div class="aaaa">
                     <el-select v-model="form.isTimingSendSms" placeholder="请选择是否定时发送短信" clearable>
                        <el-option label="开启" :value="1" style="width:100%; text-align-last: center;" />
                        <el-option label="关闭" :value="2" style="width:100%; text-align-last: center;" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item v-if="form.isTimingSendSms === 1" label="月初短信发送日期" prop="monthBeginSendDay">
                  <div class="aaaa">
                     <el-select v-model="form.monthBeginSendDay" placeholder="请选择日期" clearable>
                        <el-option v-for="d in 31" :key="d" :label="d" :value="d" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item v-if="form.isTimingSendSms === 1" label="月初短信发送时间" prop="monthBeginSendTime">
                  <div class="aaaa">
                     <el-time-picker v-model="monthBeginSendTimeTemp" placeholder="请选择月初短信发送时间" size="large" format="HH:mm" style="width: 100%" />
                  </div>
               </el-form-item>

               <el-form-item v-if="form.isTimingSendSms === 1" label="月底短信发送日期" prop="monthEndSendDay">
                  <div class="aaaa">
                     <el-select v-model="form.monthEndSendDay" placeholder="请选择日期" clearable>
                        <el-option v-for="d in 31" :key="d" :label="d" :value="d" />
                     </el-select>
                  </div>
               </el-form-item>

               <el-form-item v-if="form.isTimingSendSms === 1" label="月底短信发送时间" prop="monthEndSendTime">
                  <div class="aaaa">
                     <el-time-picker v-model="monthEndSendTimeTemp" placeholder="请选择月底短信发送时间" size="large" format="HH:mm" style="width: 100%" />
                  </div>
               </el-form-item>

               <el-form-item class="faq-form-item">
                  <template #label>
                     常见问题描述
                     <span class="referrals">( 推荐：视频体积小于100M，图片体积小于1M。 )</span>
                  </template>
                  <div style="border: 1px solid #ccc; width: 100%;">
                     <Toolbar style="border-bottom: 1px solid #ccc" :editor="walkFaqContentEditorRef" :defaultConfig="walkFaqContentToolbarConfig" mode="default" />
                     <Editor style="height: 300px; overflow-y: hidden;" v-model="walkFaqContentHtml" :defaultConfig="walkFaqContentEditorConfig" mode="default" @onCreated="handleWalkFaqContentCreated" />
                  </div>
               </el-form-item>

               <div class="submit">
                  <el-form-item>
                     <el-button type="primary" :loading="loading" @click="onSubmit" style="margin-top: 18px;">提交</el-button>
                  </el-form-item>
               </div>
            </el-form>
         </div>
      </el-card>
      <!-- 所属组织弹窗 -->
      <div>
         <el-dialog v-model="unionDialogVisible" title="所属工会" width="500px" top="10vh" custom-class="organization-dialog" :close-on-click-modal="true" destroy-on-close>
            <el-tree :data="unionTreeData" :props="unionTreeProps" accordion @node-click="handleUnionNodeClick" />
            <template #footer><el-button type="primary" @click="confirmUnion">确定</el-button></template>
         </el-dialog>
      </div>
   </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, reactive, ref, shallowRef, watch } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { standardInfo, updateStandard, ZClist } from "../../utils/api";
import qs from 'qs';
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import "@wangeditor/editor/dist/css/style.css";

const router = useRouter();
const ruleFormRef = ref(null);
const formSize = ref("large");
const loading = ref(false);

const form = reactive({
   standardType: "",
   unionName: "",
   unionCode: "",
   unionId: "",
   standardSteps: "",
   standardDays: "",
   totalStandardSteps: "",
   isShowRanking: "",
   isTimingSendSms: "",
   monthBeginSendDay: null,
   monthBeginSendTime: "",
   monthEndSendDay: null,
   monthEndSendTime: "",
   walkFaqContent: "",
});

// 月初短信发送时间
const monthBeginSendTimeTemp = ref(null);

watch(monthBeginSendTimeTemp, (val) => {
   if (val) {
      const date = new Date(val);
      form.monthBeginSendTime = date.getHours() * 3600 + date.getMinutes() * 60;
   } else {
      form.monthBeginSendTime = "";
   }
});

// 月底短信发送时间
const monthEndSendTimeTemp = ref(null);

watch(monthEndSendTimeTemp, (val) => {
   if (val) {
      const date = new Date(val);
      form.monthEndSendTime = date.getHours() * 3600 + date.getMinutes() * 60;
   } else {
      form.monthEndSendTime = "";
   }
});

// 常见问题描述富文本
const walkFaqContentEditorRef = shallowRef();
const walkFaqContentHtml = ref("");
const walkFaqContentToolbarConfig = {
   toolbarKeys: [
      'bold', 'italic', 'through', 'underline', 'bulletedList', 'numberedList',
      'color', 'fontSize', 'lineHeight', 'uploadImage', 'delIndent', 'indent',
      'deleteImage', 'justifyCenter', 'justifyJustify', 'justifyLeft', 'justifyRight',
      'undo', 'redo', 'clearStyle', 'uploadVideo',
   ],
   excludeKeys: [
      'insertImage', 'bgColor', 'blockquote', 'codeBlock', 'emotion',
      'fontFamily', 'headerSelect', 'fullScreen',
   ],
};
const walkFaqContentEditorConfig = {
   MENU_CONF: {}
};
walkFaqContentEditorConfig.MENU_CONF['uploadVideo'] = {
   server: '/admin/previous/saveEditorImage',
   headers: {
      timeout: 10000,
      'accessToken': sessionStorage.getItem('token')
   },
   maxFileSize: 104857600,
   fieldName: 'imageFile',
   maxNumberOfFiles: 1,
   onBeforeUpload(file) {
      let fileObj = Object.values(file)[0].data;
      let isLt2M = Object.values(file)[0].data.size;
      if (isLt2M < 104857600) {
         return true;
      } else if (isLt2M > 104857600) {
         ElMessage({
            message: '视频大小不能超过100MB,请重新上传',
            type: "warning",
            center: true,
         });
         return false;
      }
   },
   onSuccess(file, res) {
      console.log(file);
      console.log(res);
   },
   onError(file, res) {
      console.log(file);
      console.log(res);
      if (file.size > 104857600) {
         ElMessage({
            message: '视频大小不能超过100MB,请重新上传',
            type: "warning",
            center: true,
         });
      } else {
         ElMessage({
            message: '上传失败，请稍后再试',
            type: "warning",
            center: true,
         });
      }
   },
};
walkFaqContentEditorConfig.MENU_CONF['uploadImage'] = {
   server: '/admin/previous/saveEditorImage',
   headers: {
      timeout: 10000,
      'accessToken': sessionStorage.getItem('token')
   },
   maxFileSize: 1 * 1024 * 1024,
   fieldName: 'imageFile',
   maxNumberOfFiles: 1,
   onBeforeUpload(file) {
      let fileObj = Object.values(file)[0].data;
      let isLt2M = Object.values(file)[0].data.size;
      if (isLt2M < 1048576) {
         return true;
      } else if (isLt2M > 1048576) {
         ElMessage({
            message: '图片大小不能超过1MB,请重新上传',
            type: "warning",
            center: true,
         });
         return false;
      }
   },
   onSuccess(file, res) {
      console.log(file);
      console.log(res);
   },
   onError() {
      ElMessage({
         message: '图片大小不能超过1MB,请重新上传',
         type: "warning",
         center: true,
      });
   },
};
const handleWalkFaqContentCreated = (editor) => {
   walkFaqContentEditorRef.value = editor;
};
onBeforeUnmount(() => {
   const editor = walkFaqContentEditorRef.value;
   if (editor == null) return;
   editor.destroy();
});

// 工会选择
const unionDialogVisible = ref(false);
const unionSelectRef = ref(null);
const unionTreeData = ref([]);
const unionTreeProps = {
   children: 'unionDtoList',
   label: 'unionName',
};

const closeUnionSelect = () => {
   unionSelectRef.value && unionSelectRef.value.blur();
};

const openUnionDialog = () => {
   unionDialogVisible.value = true;
};

const handleUnionNodeClick = (node) => {
   form.unionName = node.unionName;
   form.unionCode = node.unionCode;
   form.unionId = node.unionId;
};

const confirmUnion = () => {
   unionDialogVisible.value = false;
};

const clearUnion = () => {
   form.unionName = "";
   form.unionCode = "";
   form.unionId = "";
};

const loadUnionTree = () => {
   ZClist().then((res) => {
      unionTreeData.value = res.data.data.manageUnionList;
      // 组织树加载完成后，尝试反查工会名称
      if (form.unionId) {
         const node = findUnionInTree(unionTreeData.value, form.unionId);
         if (node) {
            form.unionName = node.unionName;
            form.unionCode = node.unionCode;
         }
      }
   });
};

// 从组织树数据中递归查找工会节点
const findUnionInTree = (nodes, id) => {
   for (const node of nodes) {
      if (node.unionId === id) return node;
      if (node.unionDtoList?.length) {
         const found = findUnionInTree(node.unionDtoList, id);
         if (found) return found;
      }
   }
   return null;
};

onMounted(() => {
   loadUnionTree();
   const unionId = localStorage.getItem('unionId');
   if (unionId) {
      standardInfo(qs.stringify({ unionId })).then((res) => {
         if (res.data.code === 0) {
            const data = res.data.data.walkPowerInfo;
            console.log(data);
            form.unionId = data.unionId;
            form.standardType = data.standardType;
            form.standardSteps = data.standardSteps;
            form.standardDays = data.standardDays;
            form.totalStandardSteps = data.totalStandardSteps;
            form.isShowRanking = data.isShowRanking;
            form.isTimingSendSms = data.isTimingSendSms;
            form.monthBeginSendDay = data.monthBeginSendDay;
            form.monthBeginSendTime = data.monthBeginSendTime;
            form.monthEndSendDay = data.monthEndSendDay;
            form.monthEndSendTime = data.monthEndSendTime;
            form.walkFaqContent = data.walkFaqContent || '';
            walkFaqContentHtml.value = data.walkFaqContent || '';

            // 从已加载的组织树中反查工会名称、编码
            const node = findUnionInTree(unionTreeData.value, data.unionId);
            if (node) {
               form.unionName = node.unionName;
               form.unionCode = node.unionCode;
            }


            // 秒数转Date对象
            if (data.monthBeginSendTime != null && data.monthBeginSendTime !== '') {
               const totalSeconds = Number(data.monthBeginSendTime);
               const date = new Date();
               date.setHours(Math.floor(totalSeconds / 3600), Math.floor((totalSeconds % 3600) / 60), 0, 0);
               monthBeginSendTimeTemp.value = date;
            }
            if (data.monthEndSendTime != null && data.monthEndSendTime !== '') {
               const totalSeconds = Number(data.monthEndSendTime);
               const date = new Date();
               date.setHours(Math.floor(totalSeconds / 3600), Math.floor((totalSeconds % 3600) / 60), 0, 0);
               monthEndSendTimeTemp.value = date;
            }
         }
      });
   }
});

// 统计方式切换时清理隐藏字段并清除新显示字段的校验
watch(() => form.standardType, (newVal) => {
   if (newVal === 1) {
      form.totalStandardSteps = "";
      nextTick(() => {
         ruleFormRef.value && ruleFormRef.value.clearValidate(["totalStandardSteps", "standardSteps", "standardDays"]);
      });
   } else if (newVal === 2) {
      form.standardSteps = "";
      form.standardDays = "";
      nextTick(() => {
         ruleFormRef.value && ruleFormRef.value.clearValidate(["standardSteps", "standardDays", "totalStandardSteps"]);
      });
   } else if (newVal === 3) {
      form.standardSteps = "";
      form.standardDays = "";
      form.totalStandardSteps = "";
      nextTick(() => {
         ruleFormRef.value && ruleFormRef.value.clearValidate(["standardSteps", "standardDays", "totalStandardSteps"]);
      });
   }
});

watch(() => form.isTimingSendSms, (newVal) => {
   if (newVal !== 1) {
      form.monthBeginSendDay = null;
      form.monthBeginSendTime = "";
      form.monthEndSendDay = null;
      form.monthEndSendTime = "";
      monthBeginSendTimeTemp.value = null;
      monthEndSendTimeTemp.value = null;
   }
   nextTick(() => {
      ruleFormRef.value && ruleFormRef.value.clearValidate([
         "monthBeginSendDay",
         "monthBeginSendTime",
         "monthEndSendDay",
         "monthEndSendTime",
      ]);
   });
});

const validateNonNegative = (message) => {
   return (rule, value, callback) => {
      if (value === "" || value === null || value === undefined) {
         callback(new Error(message));
         return;
      }
      if (Number(value) < 0) {
         callback(new Error("金额不能小于0"));
         return;
      }
      callback();
   };
};

const conditionalRequired = (message, condition) => {
   return (rule, value, callback) => {
      if (!condition()) {
         callback();
         return;
      }
      if (value === "" || value === null || value === undefined) {
         callback(new Error(message));
         return;
      }
      callback();
   };
};

const rules = {
   standardType: [
      { required: true, message: "请选择统计方式" },
   ],
   unionName: [
      { required: true, message: "请选择工会" },
   ],
   standardSteps: [
      { validator: conditionalRequired("请填写每天达标步数", () => form.standardType === 1) },
   ],
   standardDays: [
      { validator: conditionalRequired("请填写达标天数", () => form.standardType === 1) },
   ],
   totalStandardSteps: [
      { validator: conditionalRequired("请填写达标总步数", () => form.standardType === 2) },
   ],
   isShowRanking: [
      { required: true, message: "请选择是否展示排行榜" },
   ],
   isTimingSendSms: [
      { required: true, message: "请选择是否定时发送短信" },
   ],
   monthBeginSendDay: [
      { required: true, message: "请选择月初短信发送日期" },
   ],
   monthBeginSendTime: [
      { required: true, message: "请选择月初短信发送时间" },
   ],
   monthEndSendDay: [
      { required: true, message: "请选择月底短信发送日期" },
   ],
   monthEndSendTime: [
      { required: true, message: "请选择月底短信发送时间" },
   ],
};

const goBack = () => {
   router.push("/walking/settingsWalk");
};

const onSubmit = () => {
   if (walkFaqContentHtml.value == '<p><br></p>') {
      form.walkFaqContent = '';
   } else {
      form.walkFaqContent = walkFaqContentHtml.value;
   }

   // 提交前按当前统计方式清洗隐藏字段
   if (form.standardType !== 1) {
      form.standardSteps = "";
      form.standardDays = "";
   }
   if (form.standardType !== 2) {
      form.totalStandardSteps = "";
   }

   ruleFormRef.value.validate((valid) => {
      if (!valid) {
         return;
      }
      loading.value = true;
      const data = {
         unionId: form.unionId,
         standardType: form.standardType,
         standardSteps: form.standardSteps,
         standardDays: form.standardDays,
         totalStandardSteps: form.totalStandardSteps,
         isShowRanking: Number(form.isShowRanking),
         isTimingSendSms: Number(form.isTimingSendSms),
         monthBeginSendDay: Number(form.monthBeginSendDay),
         monthBeginSendTime: Number(form.monthBeginSendTime),
         monthEndSendDay: Number(form.monthEndSendDay),
         monthEndSendTime: Number(form.monthEndSendTime),
         walkFaqContent: form.walkFaqContent,
      };
      updateStandard(data).then((res) => {
         if (res.data.code === 0) {
            ElMessage({
               message: "编辑成功",
               type: "success",
               center: true,
            });
            setTimeout(() => {
               goBack();
            }, 500);
         } else {
            ElMessage({
               message: res.data.msg || "编辑失败",
               type: "error",
               center: true,
            });
         }
      }).catch((error) => { if (error?.isAuthExpired) return;
         ElMessage({
            message: "编辑失败",
            type: "error",
            center: true,
         });
      }).finally(() => {
         loading.value = false;
      });
   });
};

</script>

<style lang="scss" scoped>
::v-deep .chart-card::-webkit-scrollbar {
   display: none;
}

::v-deep .chart-card {
   height: calc(100vh - 145px);
   overflow: auto;
}

::v-deep .el-button {
   width: 100px;
   height: 40px;
   font-size: 16px;
}

::v-deep .el-form-item__content {
   align-items: flex-end;
}

::v-deep .el-form-item {
   align-items: center;
}

::v-deep .aaaa {
   width: 25%;
}

::v-deep .el-card__body {
   padding: 0;
}

::v-deep .el-main {
   overflow: auto !important;
}

::v-deep .el-card.is-always-shadow {
   width: 95%;
   margin: auto;
   margin-top: 10px;
   padding-left: 20px;
   padding-right: 20px;
   padding-bottom: 20px;
}

::v-deep .tabulation {
   margin-top: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 10px;
   overflow: auto !important;
}
</style>

<style scoped>
::v-deep .el-input {
   height: 44px !important;
}

::v-deep .el-form-item__label {
   width: 138px !important;
   font-weight: bold;
}

.required-mark {
   color: var(--el-color-danger);
   margin-right: 4px;
}

::v-deep .submit {
   margin-left: 0;
}

::v-deep .el-select {
   width: 100%;
}

::v-deep .faq-form-item {
   display: block;
}

::v-deep .faq-form-item .el-form-item__label {
   display: block;
   float: none;
   width: auto !important;
   text-align: left;
   padding: 0 0 8px 0;
   height: auto;
   line-height: 1.5;
}

::v-deep .faq-form-item .el-form-item__content {
   margin-left: 0 !important;
   line-height: normal;
}

::v-deep .faq-form-item .referrals {
   color: #cccccc;
   margin-left: 5px;
   font-weight: 500;
}
</style>
